module.exports = __webpack_public_path__ + "ath_game_web/img/9.5.8ebaddc0.png";